import { useState } from "react";
import React from "react";
import Accordion from "react-bootstrap/Accordion";

const faqs = [
  {
    question: "What is OpenFundNet?",
    answer:
      "OpenFundNet is a decentralized crowdfunding platform built on blockchain. It connects innovators with a global community of funders, while using validators and a milestone-based system to ensure transparency and fairness.",
  },
  {
    question: "How does OpenFundNet work?",
    answer:
      "Projects are proposed on-chain with locked deposits. Validators review and score them. Once approved, backers fund the projects using USDT. Rewards are distributed to backers through project-specific perks and native token emissions.",
  },
  {
    question: "Is OpenFundNet safe to use?",
    answer:
      "Yes. It uses blockchain to ensure transparency and security. All transactions are public. Validators review and approve proposals, reducing the risk of scams. Security audits are planned for the near future.",
  },
  {
    question: "How can I make money on OpenFundNet?",
    answer:
      "You can earn through:\nBackers: Receive dual rewards – one from the project and daily native token emissions.\nValidators: Earn rewards for scoring and evaluating projects honestly.\nNominators: Stake tokens to trusted validators and share their emissions.",
  },
  {
    question: "How do I participate in OpenFundNet?",
    answer:
      "To get started:\nBuy OpenFundNet tokens (available during presale and later on exchanges).\nChoose a role: backer, validator, or nominator.\nFund or evaluate projects you trust.",
  },
  {
    question: "Is there a presale?",
    answer:
      "Yes. OpenFundNet will have a presale stage, giving early supporters the chance to buy tokens at a discounted rate before they’re listed on exchanges.",
  },
  {
    question: "What kinds of projects can I fund?",
    answer:
      "Any type of project can apply, though software projects are highly recommended. All projects are milestone-based, with funding released gradually as goals are met.",
  },
  {
    question: "How are projects approved?",
    answer:
      "Validators evaluate proposals based on innovation, clarity, potential, and more. A proposal needs over 50% validator stake approval to be accepted.",
  },
  {
    question: "What makes OpenFundNet different from other platforms?",
    answer:
      "On-chain, decentralized system\nValidator-based project approval\nDual rewards for backers\nTrust scoring and staking for validators\nDAO governance\nMilestone-based funding\nZero big user fees",
  },
  {
    question: "What do I need to become a Project Manager?",
    answer:
      "Submit an innovative idea, complete KYC, provide a roadmap, GitHub repo, and community presentation. Lock a deposit in tokens and submit the on-chain proposal.",
  },
  {
    question: "How do I reward my backers?",
    answer:
      "Backers receive two types of rewards:\nProject rewards (e.g. perks, USDT, etc.) you promise in your listing\nDaily native token emissions distributed automatically",
  },
  {
    question: "Can I get my money back if a project fails?",
    answer:
      "No. Contributions are non-refundable. However, milestone-based funding, validator reviews, and public accountability help reduce risks.",
  },
  {
    question: "Can I trade my tokens outside the platform?",
    answer:
      "Yes. OpenFundNet tokens will be listed on centralized exchanges (CEXs).",
  },
  {
    question: "What protects me as a backer?",
    answer:
      "Validator approval\nMilestone-based funding\nPublic project tracking\nDual rewards (project + platform)",
  },
  {
    question: "Can anyone join OpenFundNet?",
    answer: "Yes. It’s open to users from all over the world.",
  },
  {
    question: "Can validators or nominators be penalized?",
    answer:
      "Yes. Validators who submit dishonest scores receive lower trust scores, which reduce their rewards. Nominators share in rewards based on validator performance.",
  },
  {
    question: "What is a Validator?",
    answer:
      "A Validator reviews and scores projects. They must stake tokens and maintain high trust scores to maximize rewards.",
  },
  {
    question: "How do I become a Validator?",
    answer:
      "Stake enough native tokens and actively participate in project evaluations.",
  },
  {
    question: "What is a Nominator?",
    answer:
      "Nominators delegate their tokens to trusted validators and earn a share of their emissions (82%).",
  },
  {
    question: "How are Validators rated?",
    answer:
      "Based on trust score. Honest, consistent evaluations lead to higher scores and better rewards.",
  },
  {
    question: "How does OpenFundNet make money if there are no big fees?",
    answer:
      "It earns through token emissions, treasury growth, and long-term token value. It’s a sustainable, community-first model.",
  },
  {
    question: "Can I vote on changes to the platform?",
    answer:
      "Yes. Token holders can vote on upgrades, reward systems, and how community funds are used.",
  },
  {
    question: "What if I have an idea but no token?",
    answer:
      "You’ll need to acquire OpenFundNet tokens (via presale or exchange) to lock in a deposit when proposing your project.",
  },
  {
    question: "What is the deflationary mechanism of the token?",
    answer:
      "Part of transaction fees are burned. Inactive validators and nominators may lose future emissions to keep the network dynamic.",
  },
  {
    question: "Are there risks to supporting a project?",
    answer:
      "Yes. As with any investment, there are risks. Use validator scores and project transparency as your guide—and only support projects you trust.",
  },
];

const Faqs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 5;

  const totalPages = Math.ceil(faqs.length / perPage);
  const currentFAQs = faqs.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  return (
    <div className="Introducing  ">
      <div className="faqs  ">
        <h2 className="text-center">
          {" "}
          <span>FAQ</span>
        </h2>
        {/* <div className="text-center">
          <div className="line mb-3"></div>
        </div> */}
        <p className="text-center mb-5 p">Seamless customer experience</p>
        <div className="container">
          <div className="row ">
            <div className="col-lg-2"></div>
            <div
              className="col-lg-8 mb-5 mb-lg-0"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <Accordion className="faq-accordion" defaultActiveKey="0">
                {currentFAQs.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={(currentPage - 1) * perPage + index}
                  >
                    <Accordion.Header>
                      <span className="point"></span> {faq.question}
                    </Accordion.Header>
                    <Accordion.Body style={{ whiteSpace: "pre-wrap" }}>
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            <div className="mt-5 d-flex justify-content-center gap-5 align-items-center">
              <button
              className="btn-outline"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <div style={{color: "#fff"}}>
                {currentPage} of {totalPages}
              </div>
              <button
              className="btn-outline"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
